import React, { useContext, useEffect, useState } from "react";
import { FailurePop, SuccessPop } from "../Popup";
import { useTheme } from "@mui/material/styles";
import Draggable from "react-draggable";
import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Slide,
  Paper,
  IconButton,
  TextField,
  InputAdornment,
} from "@mui/material";
import { CloseSharp, Search } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { AppContext } from "../context/app.context";

import { useDispatch, useSelector } from "react-redux";
import BranchCartDeletePop from "./BranchCartDeletePop";
import { CurrentBranch } from "../reducers/config";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const FindBranchPop = ({
  setOpenFindBranch,
  openFindBranch,
  setNearestPop,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const ca = useSelector((data) => data.cLoc);
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { setBranchValue, userDetail, cartList } = useContext(AppContext);

  //useState
  const [modalFail, setModalFail] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [content, setContent] = useState("");
  const [searchList, setSearchList] = useState([]);
  const [branchCartDelete, setBranchCartDelete] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [search, setSearch] = useState([]);

  const getDetail = async () => {
    const { langitude, latitude } = ca || {};
    if (langitude && latitude) {
      await fetchBranchList(langitude, latitude);
    } else if (global?.$userData?.latitude && global?.$userData?.langitude) {
      await fetchBranchList(
        global.$userData.langitude,
        global.$userData.latitude
      );
    } else if (userDetail?.latitude && userDetail?.langitude) {
      await fetchBranchList(userDetail.langitude, userDetail.latitude);
    } else {
      await getLocation();
    }
  };

  const getLocation = async () => {
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then(async (permissionStatus) => {
          if (permissionStatus.state === "denied") {
            console.log("Denied");
          } else {
            navigator.geolocation.getCurrentPosition(success, error);
          }
        });
    } else {
      alert("Geolocation is not supported in your browser.");
    }
  };

  function success(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;

    fetchBranchList(longitude, latitude);
  }

  const error = async () => {
    console.log("Unable to retrieve your location");
  };

  async function filterList(data, e) {
    if (e) {
      const d = data.filter((item) => {
        return (
          e
            .toLowerCase()
            .split(" ")
            .every((v) => item?.name?.toLowerCase().includes(v)) ||
          e
            .toLowerCase()
            .split(" ")
            .every((v) => item?.distance?.toLowerCase().includes(v))
        );
      });
      setSearch(d);
    } else {
      setSearch(data);
    }
  }

  const fetchBranchList = async (lng, ltd) => {
    try {
      const response = await global.$axios.post("location/listBranch", {
        Longitude: lng,
        Latitude: ltd,
      });

      if (response.data.status == "success") {
        setSearchList(response.data.message);
        filterList(response.data.message, "");
      } else {
        setSearchList([]);
      }
    } catch (error) {
      console.log("Search Branch Issue", error);
    }
  };

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={openFindBranch}
        fullWidth={true}
        maxWidth={"sm"}
        TransitionComponent={Transition}
        aria-labelledby="draggable-dialog-title"
        PaperComponent={PaperComponent}
        onClose={() => setOpenFindBranch(false)}
      >
        <Grid sx={{ py: 2, px: 3 }}>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <DialogTitle>
              <Typography sx={{ p: 0, color: "#071CB7", fontWeight: 600 }}>
                Search Branch
              </Typography>
            </DialogTitle>
            <IconButton
              sx={{ p: 0 }}
              onClick={() => {
                setOpenFindBranch(false);
              }}
            >
              <CloseSharp sx={{ color: "red" }} />
            </IconButton>
          </Grid>
          <DialogContent style={{ padding: 0 }}>
            <Grid
              sx={{
                my: 5,
              }}
            >
              {/* <Autocomplete
                value={searchValue}
                onChange={(event, newValue) => {
                  if (cartList && cartList?.length > 0) {
                    setSelectedData(newValue);
                    setBranchCartDelete(true);
                  } else {
                    setBranchValue(newValue);
                    dispatch(CurrentBranch(newValue));
                    setNearestPop(false);
                    setOpenFindBranch(false);
                  }
                }}
                noOptionsText={"No Branches Found"}
                options={searchList}
                size="small"
                autoComplete
                fullWidth
                getOptionLabel={(option) => option.distance || ""}
                isOptionEqualToValue={(option, value) =>
                  option.distance == value.distance
                }
                sx={{ width: "80%" }}
                renderInput={(params) => (
                  <TextField
                    label="Search here..."
                    variant="outlined"
                    {...params}
                    sx={{
                      ".css-12yjm75-MuiInputBase-input-MuiOutlinedInput-input":
                        { fontSize: 14 },
                    }}
                  />
                )}
              /> */}
              <TextField
                onChange={(e) => filterList(searchList, e.target.value)}
                placeholder="Enter the Branch Name or Distance"
                size="small"
                fullWidth
                InputProps={{
                  type: "search",
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />

              <Grid
                sx={{
                  minHeight: "30vh",
                  maxHeight: "30vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                  mt: 2,
                  px: 1,
                }}
              >
                {search?.length > 0 ? (
                  search?.map((item, index) => {
                    return (
                      <Grid
                        key={index + 1}
                        sx={{
                          my: 2,
                          px: 2,
                          py: 1,
                          background: "#FFF",
                          boxShadow: 5,
                          borderRadius: 1,
                          justifyContent: "space-between",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        container
                        onClick={() => {
                          if (cartList && cartList?.length > 0) {
                            setSelectedData(item);
                            setBranchCartDelete(true);
                          } else {
                            setBranchValue(item);
                            dispatch(CurrentBranch(item));
                            setNearestPop(false);
                            setOpenFindBranch(false);
                          }
                        }}
                      >
                        <Typography sx={{ width: "80%", flexWrap: "wrap" }}>
                          {item.name}
                        </Typography>
                        <Typography>{item.distance}</Typography>
                      </Grid>
                    );
                  })
                ) : (
                  <Grid
                    sx={{
                      alignItems: "center",
                      justifyContent: "center",
                      mt: 10,
                    }}
                    container
                  >
                    <Typography sx={{ fontWeight: 600 }}>
                      No Branch Found!!!
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </DialogContent>
        </Grid>
      </Dialog>
      {modalSuccess && (
        <SuccessPop
          modalSuccess={modalSuccess}
          setModalSuccess={setModalSuccess}
          content={content}
        />
      )}

      {modalFail && (
        <FailurePop
          modalFail={modalFail}
          setModalFail={setModalFail}
          content={content}
        />
      )}

      {branchCartDelete && (
        <BranchCartDeletePop
          branchCartDelete={branchCartDelete}
          setBranchCartDelete={setBranchCartDelete}
          selectedBranch={selectedData}
          setOpenFindBranch={setOpenFindBranch}
        />
      )}
    </React.Fragment>
  );
};

export default FindBranchPop;
